export interface ConsentState {
  analytics: boolean;
  marketing: boolean;
  timestamp: number;
}

/**
 * Get the current consent state from localStorage
 */
export const getConsentState = (): ConsentState | null => {
  try {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) return null;
    return JSON.parse(consent);
  } catch (error) {

    return null;
  }
};

/**
 * Check if the user has given consent for analytics
 */
export const hasAnalyticsConsent = (): boolean => {
  const consent = getConsentState();
  return consent?.analytics === true;
};

/**
 * Check if the user has given consent for marketing
 */
export const hasMarketingConsent = (): boolean => {
  const consent = getConsentState();
  return consent?.marketing === true;
};

/**
 * Check if the user has given any consent (banner has been interacted with)
 */
export const hasGivenConsent = (): boolean => {
  return getConsentState() !== null;
};

/**
 * Clear consent state (useful for testing or reset functionality)
 */
export const clearConsent = (): void => {
  localStorage.removeItem('cookie-consent');
  
  // Also update GTM consent mode to denied
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('consent', 'update', {
      'ad_storage': 'denied',
      'ad_user_data': 'denied',
      'ad_personalization': 'denied',
      'analytics_storage': 'denied'
    });
  }
};

// Extend the global Window interface for TypeScript
declare global {
  interface Window {
    gtag: (command: string, action: string, parameters: any) => void;
    dataLayer: any[];
  }
} 